<template>
    <my-popup :update.sync="update" :visible.sync="show">
        <type-wrapper class="get-user-info" padding>
            <my-icon size="24px" icon="close" color="#000000" class="get-user-info-close" v-if="showClose" @click="close"></my-icon>
            <type-text type="title" size="3" padding="0">{{ title }}</type-text>
			<type-input clearable whitebackdrop v-model="name" placeholder="Name" style="margin-top: 20px;" v-if="type !== 'login'"></type-input>
			<type-input clearable whitebackdrop v-model="email" placeholder="Email" style="margin-top: 20px;"></type-input>
			<type-input clearable whitebackdrop v-model="password" type="password" placeholder="Password" style="margin-top: 20px;" v-if="type !== 'buy'"></type-input>
			<type-input clearable whitebackdrop v-model="repassword" type="password" placeholder="Repeat Password"style="margin-top: 20px;" v-if="type === 'register'"></type-input>
			<p class="jump-type" @click="toggleType('login')" v-if="type === 'register'">to login</p>
			<p class="jump-type" @click="toggleType('register')" v-if="type === 'login'">to register</p>
			<type-button whitebackdrop border style="margin-top: 30px;" @click="submitInfo">{{ title }}</type-button>
        </type-wrapper>
    </my-popup>
</template>

<script>
	export default {
		name: 'get-user-info',
		data() {
			return {
				type: '',
                show: false,
                update: true,
				name: '',
				email: '',
				password: '',
				repassword: '',
				showClose: false,
                closeResolve: null
			}
		},
		methods: {
            close() {
                if (this.closeResolve && typeof this.closeResolve === 'function') {
                    this.closeResolve({
                        status: 'error',
                        type: 'close',
                        data: this.$userInfo.data
                    });
                }
                this.show = false;
            },
			showPopup(type = 'buy', showClose = false) {
				return new Promise(resolve => {
					this.judgeShowPopup(type).then(isShow => {
						if (isShow) {
							const that = this;
							this.name = this.$userInfo.data.name || '';
							this.email = this.$userInfo.data.email || '';
							this.type = type;
							this.password = '';
							this.repassword = '';
                            this.showClose = Boolean(showClose);
                            this.closeResolve = resolve;
                            this.show = true;
						} else {
							resolve(this.$userInfo.data);
						}
					});
				});
			},
            toggleType(type) {
                this.type = type;
                this.update = true;
            },
			submitInfo() {
                const data = Object.create(null);
                data['email'] = this.email;
				if (this.type === 'buy') {
					data.name = this.name;
				}
                if (this.type === 'login') {
					data.password = this.password;
				}
                if (this.type === 'register') {
					data.name = this.name;
					data.password = this.password;
					data.repassword = this.repassword;
				}
				const result = this.$verify.verify(data);
				if (result.tip) {
					// 弹出消息提示
					this.$message(result.tip);
				} else {
					if (this.type === 'buy') {
                        this.reportBug(data);
					}
					if (this.type === 'login') {
                        this.userLogin(data);
					}
					if (this.type === 'register') {
                        this.userRegister(data);
					}
				}
			},
			async reportBug(data = {}) {
				const content = Object.keys(data).map(key => `${key}=${data[key]}`).join('&');
				const { status } = await this.$http.user.report_bug(content);
                if (status !== 'success') {
                    return;
                }
                this.$userInfo.setData({
                    name: data.name,
                    time: this.$time.now.timestamp,
                    email: data.email
                });
                if (this.closeResolve && typeof this.closeResolve === 'function') {
                    this.closeResolve({
                        status: 'success',
                        type: 'buy',
                        data: this.$userInfo.data
                    });
                }
                this.show = false;
			},
			async userLogin(data = {}) {
                const loginResult = await this.$http.user.login(data);
                if (loginResult.status !== 'success') {
                    return;
                }
                this.$userInfo.setData({
                    time: this.$time.now.timestamp,
                    email: data.email,
                    user_info: loginResult.data
                });
                const profileResult = await this.$http.user.profile(loginResult.data.access_token);
                if (profileResult.status !== 'success') {
                    return;
                }
                this.$userInfo.setData({
                    name: profileResult.data.name || '',
                    time: this.$time.now.timestamp,
                    email: data.email,
                    user_info: Object.assign(loginResult.data, profileResult.data)
                });
                if (this.closeResolve && typeof this.closeResolve === 'function') {
                    this.closeResolve({
                        status: 'success',
                        type: 'login',
                        data: this.$userInfo.data
                    });
                }
                this.show = false;
			},
			async userRegister(data = {}) {
				const registerResult = await this.$http.user.register({
					email: data.email,
					password: data.password,
					repassword: data.repassword
				});
                if (registerResult.status !== 'success') {
                    return;
                }
                this.$userInfo.setData({
                    name: data.name,
                    time: this.$time.now.timestamp,
                    email: data.email,
                    user_info: registerResult.data
                });
                const setProfileResult = await this.$http.user.set_profile({
                    name: data.name,
                    is_private: '1',
                    access_token: registerResult.data.access_token
                });
                if (setProfileResult.status !== 'success') {
                    return;
                }
                const profileResult = await this.$http.user.profile(registerResult.data.access_token);
                if (profileResult.status !== 'success') {
                    return;
                }
                this.$userInfo.setData({
                    name: data.name,
                    time: this.$time.now.timestamp,
                    email: data.email,
                    user_info: Object.assign(registerResult.data, profileResult.data)
                });
                if (this.closeResolve && typeof this.closeResolve === 'function') {
                    this.closeResolve({
                        status: 'success',
                        type: 'register',
                        data: this.$userInfo.data
                    });
                }
                this.show = false;
			},
			async judgeShowPopup(type = 'buy') {
                // // 一律直接显示，可能需要别的账号购买
                // return true;
                // 如果是买不需要登录注册
                if (type === 'buy') {
                    if (this.$userInfo.data.name && this.$userInfo.data.email) {
                    	return false;
                    }
                    return true;
                }
                const access_token = this.$userInfo.data.access_token || '';
                if (access_token) {
                    const { status, data } = await this.$http.user.profile(access_token);
                    if (status === 'success') {
                        this.$userInfo.setData(data);
                        return false;
                    }
                }
                return true;
			}
		},
		computed: {
			title() {
				const titles = {
					'buy': 'Buy',
					'register': 'Register',
					'login': 'Login'
				};
				return titles[this.type];
			}
		}
	}
</script>

<style scoped lang="less">
	.get-user-info{
        width: calc(100vw - 90px);
        max-width: 500px;
        min-width: 240px;
        position: relative;
        background-color: #FFFFFF;
        .get-user-info-close{
            position: absolute!important;
            right: 8px;
            top: 8px;
        }
        .jump-type{
        	cursor: pointer;
			margin-top: 20px;
        	text-align: right;
        	&:hover{
        		color: #41466E;
        		text-decoration: underline;
        		text-decoration-color: #41466E;
        	}
        }
	}
</style>
